// extracted by mini-css-extract-plugin
export default {"box":"Ribbon_box__+00-0","ribbon":"Ribbon_ribbon__EC2ty","ribbonBottomRight":"Ribbon_ribbonBottomRight__yMFAh"};